import React from 'react'
import Link from 'gatsby-link'

import './style.css'

const Menu = () => {

    return (

        <div className="menuCont">
            <ul className="menu">
                <li><Link to="/" className="home" /></li>
                <li className="blue"><Link to="/who-we-are" activeClassName="blue">Who We Are</Link></li>
                <li className="orange"><Link to="/our-story" activeClassName="orange">Our Story</Link></li>
                <li className="pink"><Link to="/what-we-do" activeClassName="pink">What We Do</Link></li>
                <li className="green"><Link to="/what-you-can-do" activeClassName="green">What You Can Do</Link></li>
                <li className="blue"><Link to="/our-trustees" activeClassName="blue">Our Trustees</Link></li>
                <li className="orange"><Link to="/our-supporters" activeClassName="orange">Our Supporters</Link></li>
                <li className="pink"><Link to="/our-news" activeClassName="pink">Our News</Link></li>
                <li className="green"><Link to="/contact-us" activeClassName="green">Contact Us</Link></li>
            </ul>
        </div>

    )

}

export default Menu


// WEBPACK FOOTER //
// ./src/components/menu.js